<div class="flex flex-col items-start bg-background-light p-8">
  <h1 class="typo-h1 mb-6 font-semibold text-text-primary">{{ 'ffd_notes_activate_title' | translate }}</h1>

  <div class="flex w-full flex-col gap-5">
    <div class="rounded-2xl border border-background-disabled bg-background-white p-8 shadow-sm">
      <div class="flex items-start justify-between gap-6">
        <div>
          <h2 class="typo-h2 mb-4 font-semibold text-text-primary">{{ 'ffd_notes_activate_step1_title' | translate }}</h2>
          <ol class="space-y-3">
          <li class="typo-h3-light flex items-start gap-3 text-text-secondary">
            <span class="typo-h3-medium flex-shrink-0">1.</span>
            <span>
              {{ 'ffd_notes_activate_step1_item1_prefix' | translate }}
              <img src="assets/images/ffd-notes-sign-up-modal/notes-app-icon.png" alt="" class="ml-1 mr-1 inline-block w-5 align-text-bottom" />
              <strong class="font-bold">{{ 'ffd_notes_activate_step1_item1_brand' | translate }}</strong>
              {{ 'ffd_notes_activate_step1_item1_suffix' | translate }}
            </span>
          </li>
          <li class="typo-h3-light flex items-start gap-3 text-text-secondary">
            <span class="typo-h3-medium flex-shrink-0">2.</span>
            <span>
              {{ 'ffd_notes_activate_step1_item2_prefix' | translate }}
              <svg-icon key="px-24-qr" class="mx-1 inline-block max-h-5 max-w-5 align-text-bottom"></svg-icon>
              {{ 'ffd_notes_activate_step1_item2_suffix' | translate }}
            </span>
          </li>
          <li class="typo-h3-light flex items-start gap-3 text-text-secondary">
            <span class="typo-h3-medium flex-shrink-0">3.</span>
            <span>{{ 'ffd_notes_activate_step1_item3' | translate }}</span>
          </li>
          </ol>
        </div>
        <qrcode
          [qrdata]="qrData()"
          [width]="qrCodeSize"
          [errorCorrectionLevel]="'L'"
          [margin]="3"
          [allowEmptyString]="true"
          [elementType]="'canvas'"
          [imageSrc]="'assets/images/logo-qr-black.png'"
          [imageHeight]="logoSize"
          [imageWidth]="logoSize"
        ></qrcode>
      </div>
    </div>


    <div class="flex items-center justify-between rounded-2xl border border-background-disabled bg-background-white p-8 shadow-sm">
      <div>
        <h2 class="typo-h2 mb-3 font-semibold text-text-primary">{{ 'ffd_notes_activate_step2_title' | translate }}</h2>
        <p class="typo-h3-light mb-3 text-text-secondary">{{ 'ffd_notes_activate_step2_description' | translate }}</p>
      </div>
      <button
        (click)="onSyncMyNotes()"
        class="ml-6 flex-shrink-0 rounded-2xl bg-primary-blue px-6 py-3 font-semibold text-background-white"
      >
        {{ 'ffd_notes_activate_cta' | translate }}
      </button>
    </div>
  </div>
</div>
